import { observable, action } from 'mobx';
import agent from '../../services/web/agent';
import commonValidators from '../../services/validations/commonValidators';
import _ from 'lodash';
import { setter } from 'mobx-decorators';

class LdapRoleMappingsStore {

    @setter @observable updateLdapServerRoleMappingsErrorMessage;

    @observable ldapRoleMappings = null;

    @action reset() {
        this.setUpdateLdapServerRoleMappingsErrorMessage('');
        this.ldapRoleMappings = null;
    }

    @action getLdapRoleMappings(ldapServerId) {

        return agent.LDAPRoleMappings.getRoleMappingsByLdapServerId(ldapServerId)
            .then(action((ldapRoleMappings) => {
                this.ldapRoleMappings = ldapRoleMappings;
                this.ldapRoleMappings.map(m => ({ ...m, roleIdValidationMessage: '', roleIdValid: true }));
                if (this.ldapRoleMappings.length < 1) {
                    this.addMapping(ldapServerId);
                }
            }
            ));
    }

    @action removeMapping(mappingId) {

        this.ldapRoleMappings = this.ldapRoleMappings.filter(m => m.id != mappingId);
    }

    @action addMapping(ldapServerId) {
        this.ldapRoleMappings.push({
            id: _.uniqueId('pending_'),
            ldapServerId: ldapServerId,
            roleId: null,
            ldapGroupDn: '',
            ldapGroupDisplayName: '',
            roleIdValidationMessage: '',
            roleIdValid: true,
            groupDnValidationMessage: '',
            groupDnValid: true
        });
        this.ldapRoleMappings = this.ldapRoleMappings.map((m) => m);
    }

    @action setMappingRole(mappingId, roleId) {
        var mapping = this.ldapRoleMappings.find(function (m) { return m.id === mappingId; });
        mapping.roleId = roleId;
        this.ldapRoleMappings = this.ldapRoleMappings.map((m) => m);
    }

    @action setMappingGroupDn(mappingId, ldapGroupDn) {
        var mapping = this.ldapRoleMappings.find(function (m) { return m.id === mappingId; });
        mapping.ldapGroupDn = ldapGroupDn;
        mapping.ldapGroupDisplayName = this.extractGroupDisplayName(ldapGroupDn);
        this.ldapRoleMappings = this.ldapRoleMappings.map((m) => m);
    }

    extractGroupDisplayName(ldapGroupDn) {
        const splitArr = ldapGroupDn.split(',')[0].trim().split('=');
        return splitArr.length > 1 ? splitArr[1].trim() : '';
    }


    @action validateMappingRoleId(mappingId, roleId) {

        const validation = commonValidators.validateInteger(roleId);
        var mapping = this.ldapRoleMappings.find(function (m) { return m.id === mappingId; });

        mapping.roleIdValidationMessage = validation.errors.first('number');
        mapping.roleIdValid = validation.errorCount == 0 ? true : false;
    }

    @action validateMappingGroupDn(mappingId) {

        var mapping = this.ldapRoleMappings.find(function (m) { return m.id === mappingId; });
        const validation = commonValidators.validateGenericRequiredField(mapping.ldapGroupDn);

        mapping.groupDnValidationMessage = validation.errors.first('field');
        mapping.groupDnValid = validation.errorCount == 0 ? true : false;

    }

    @action validateAllMappings() {

        var _this = this;
        this.ldapRoleMappings.forEach(function (mapping) {
            _this.validateMappingRoleId(mapping.id, mapping.roleId);
            _this.validateMappingGroupDn(mapping.id, mapping.ldapGroupDn);
        });


        if (this.ldapRoleMappings.filter((m) => m.roleIdValid == false || m.groupDnValid == false).length > 0) {
            return false;
        }

        return true;
    }

    @action updateLdapServerRoleMappings(ldapServerId) {

        this.setUpdateLdapServerRoleMappingsErrorMessage('');

        return agent.LDAPRoleMappings.putLdapServerRoleMappings(ldapServerId,
            this.ldapRoleMappings.map(m => ({ roleId: m.roleId, ldapGroupDn: m.ldapGroupDn.trim(), ldapGroupDisplayName: m.ldapGroupDisplayName })))
            .then(action(function () {
            }))
            .catch(action((err) => {
                this.editUserProfileErrorMessage = 'Failed to update profile';

                if (err && err.response && err.response.text) {
                    const errorMsg = JSON.parse(err.response.text).Message;
                    this.setUpdateLdapServerRoleMappingsErrorMessage(errorMsg);
                }

                throw err;
            }));
    }
}

export default new LdapRoleMappingsStore();